import Typography from "@mui/material/Typography";
import getDisclosuresData from "./getDisclosuresData";
import useTracker from "components/CTracker/useTrackerContext";
import { Status } from "typedef/Loan";
import CTrackerTimelineItem from "components/CTimelineItem";
import { TrackerStatusColor } from "typedef/TrackerStatusColor";

const ClosingDisclosuresVerification: React.FC<{
  trackerStatusColor: TrackerStatusColor;
}> = ({ trackerStatusColor }) => {
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const prevStep =
    loan?.borrowerSteps?.scheduleClosingVerification.status === "success";
  const { status, message } = prevStep
    ? getDisclosuresData(step)
    : { status: "pending" as Status, message: "" };

  return (
    <CTrackerTimelineItem
      last={!isBorrower}
      status={status}
      title="Closing Disclosures"
      tooltip="Your Closing Disclosures contain your full closing package. These documents will be signed on your closing date."
      {...(status === "analyzing" &&
        message &&
        loan &&
        prevStep && {
          message: message,
        })}
    >
      <Typography variant="h6" color={[trackerStatusColor[status]]}>
        {status === "analyzing" && message}
        {status === "failed" && message}
        {status === "success" && message}
      </Typography>
    </CTrackerTimelineItem>
  );
};

export default ClosingDisclosuresVerification;
